























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductsApi, User, UsersApi } from '@/api';
import TitleMixin from '@/mixins/title-mixin';
import Toast from '@/components/display/toast.vue';
import { BvTableFieldArray } from 'bootstrap-vue';
import { RepairJobTextAudit, AuditRepairJobText } from '@/models/extensions';
import { ApiUtils } from '@/common/ApiUtils';

@Component({
	components: {},
	mixins: [TitleMixin],
})
export default class RepairJobTexts extends Vue {
	public smallScreen = window.innerWidth < 1000;

	@Prop(Number)
	public productId?: number;

	public product: any | null = null;
	public sentTexts: RepairJobTextAudit[] = [];

	public loadingSentTexts = true;

	public sentTextsSortBy: string = 'id';
	public sentTextsSortDesc = true;

	public sentTextsFields: BvTableFieldArray = [
		{ key: 'id', label: 'Id', sortable: true },
		{ key: 'notifiedUser.name', label: 'Notified User', sortable: true },
		{ key: 'notifiedUser.phone', label: 'Sent SMS To', sortable: true },
		{ key: 'new_values.simproJobId', label: 'SimPRO Job Id', sortable: true },
		{ key: 'new_values.zendeskTicketId', label: 'Zendesk Ticket Id', sortable: true },
		{ key: 'new_values.sentAt', label: 'Sent At', sortable: true },
	];

	private productApi: ProductsApi = new ProductsApi();
	private userApi: UsersApi = new UsersApi();

	public async load() {
		await this.loadSentTexts();
	}

	private async getUser(sentTextId?: number, userId?: number): Promise<User | null> {
		if (!userId) return null;
		try {
			return <User>(await this.userApi.getUserId(userId))?.data;
		} catch (e) {
			const { errorMessage } = ApiUtils.handleApiError(
				e,
				`Error ${e.response.status} loading user details for the notified user for sent text ID: ${sentTextId}`,
			);
			new Toast().makeToast(errorMessage, 'Error', 'danger', true);
			return null;
		}
	}

	private async loadSentTexts() {
		if (!this.productId) return;
		this.loadingSentTexts = true;
		try {
			const { data } = await this.productApi.getSentTexts(this.productId);
			let texts = <RepairJobTextAudit[]>(data.data ?? []);
			for (let index in texts) {
				const text = texts[index];
				text.new_values = JSON.parse(text.new_values?.toString() ?? '');

				const user = await this.getUser(
					text?.id,
					(<AuditRepairJobText>text?.new_values)?.notifiedUserId,
				);
				if (user) text.notifiedUser = user;
				else text.notifiedUser = { name: '', phone: '', firstName: '', lastName: '', email: '' };
			}
			this.sentTexts = texts;
		} catch (e) {
			this.sentTexts = [];
			const { errorMessage } = ApiUtils.handleApiError(
				e,
				'An unknown error occurred loading sent texts',
			);
			new Toast().makeToast(errorMessage, 'Error', 'danger', true);
		}
		this.loadingSentTexts = false;
	}

	public created() {
		this.load();
	}
}
